export function createAction(type, payload) {
    return payload === undefined
        ? { type }
        : { type, payload };
}
export function throwType(p) {
    throw new Error('Unknown type: ' + p);
}
//# sourceMappingURL=utils.js.map